import { IAttributes, IAugmentedJQuery, IDirective, IScope, ITimeoutService } from 'angular';
import { CheckDropdownSelectCtrl } from './check-dropdown-select.component';

export function checkDropdownOptionDirective( $timeout: ITimeoutService ): IDirective {
  return {
    require: '^checkDropdownSelect',
    compile: ( tElement: IAugmentedJQuery ) => {
      tElement.addClass('check-dropdown-option');
      return ( $scope: IScope, $element: IAugmentedJQuery, attrs: IAttributes, checkDropdownCtrl: CheckDropdownSelectCtrl ) => {
        $element.on('click', () => {
          $timeout(() => {
            checkDropdownCtrl.toggleOpen();
          });
        });
      };
    }
  };
}

checkDropdownOptionDirective.$inject = [
  '$timeout'
];



// WEBPACK FOOTER //
// ./app/ui/check-dropdown-select/check-dropdown-option.directive.ts